
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/doctors",
      function () {
        return require("private-next-pages/explore/doctors/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/doctors"])
      });
    }
  